APP.Form = (/** @lends APP.Login */function () {
	'use strict';

	var exports = {},
		$body;

	function init() {
		$body = APP.Performance.getCachedDOM().$body;
		initBindings();
	}

	function initBindings() {
		$body.on('submit', '[data-service-form]', onSubmitForm);
	}

	function onSubmitForm(event) {
		var $form = $(this),
			formData,
			url = $form.attr('data-action') || document.location.href,
			isDisable = typeof $form.attr('data-disable-onsubmit') !== 'undefined',
			callback = $form.attr('data-callback') || false;


		$form.addClass('sc-form--loading');
		$form.find('[data-form-element]').removeClass('sc-form__wrapper--show-error');
		event.preventDefault();
		formData = $form.serializeObject();

		if(isDisable) {
			disableForm($form, true);
		}

		APP.Service.post(formData, url).then(function (response) {
			$form.removeClass('sc-form--loading');
			disableForm($form, false);

			if (response.success) {

				if (url === '/api/v1/account/add') {
					APP.Analytics.trackEvent('Subscription', 'Add', 'Mobile number / Yettel ID');
				}

				if (url === '/api/v1/account/cancel-registration') {
					APP.Analytics.trackEvent('Account', 'Delete', '');
				}

				if (url === '/api/v1/ctn-settings/editbasic') {
					APP.Analytics.trackEvent('Subscription', 'Edit settings', '');

					if (formData && formData.password && formData.password !== '') {
						APP.Analytics.trackEvent('Subscription', 'Modify', 'Password');
					}
				}

				if (url === '/api/v1/account/edit') {
					APP.Analytics.trackEvent('Subscription', 'Rename', '');
				}

				if (url === '/api/v1/ctn-settings/change-password') {
					APP.Analytics.trackEvent('Subscription', 'Modify', 'Password');
				}

				if (callback) {
					executeFunctionByName(callback, window, response.data, $form);
				}

				if (response.redirect) {
					document.location.href = response.redirect;
				}

			} else {

				APP.Analytics.trackEvent('Error', 'Form', response.id);

				addErrors($form, response.errors);
				if (response.errors._global) {
					if (url === '/ctn_sms_add') {
						APP.DataTable.resetCtnSmsForm();
					}
					window.parent.APP.Layout.alert(response.errors._global.join('<br>'), 'Hiba');
				}

			}

		});
	}

	function disableForm($form, state) {
		$form.find('input, select').each(function() {
			if(typeof $(this).attr('data-no-disable') !== 'undefined' ||
				typeof $(this).attr('data-form-no-enable') !== 'undefined') {
				return true;
			}

			$(this).prop('disabled', state);

			if($(this).is('select')) {
				$(this).selectric('refresh');
			}
		});
	}

	function executeFunctionByName(functionName, rawContext) {
		var args = [].slice.call(arguments).splice(2),
			context = rawContext,
			ns = functionName.split('.'),
			func = ns.pop(),
			i = 0;

		for (i; i < ns.length; i++) {
			context = context[ns[i]];
		}
		return context[func].apply(this, args);
	}

	function addErrors($form, errorMessages) {
		var key;

		for (key in errorMessages) {
			if (errorMessages.hasOwnProperty(key)) {
				addError($form.find('[name="' + key + '"]'), errorMessages[key][0]);
			}
		}

		APP.Tooltip.updateWithin($form);

	}

	function addError($element, errorMsg) {
		var $wrapper = $element.parents('[data-form-element]').first(),
			$errorIcon = $wrapper.find('[data-error-icon]'),
			$errorContainer = null;

		if ($element.length === 0) {
			return false;
		}

		if ($errorIcon.length > 0) {
			$errorIcon.tipso('update', 'content', errorMsg);
		} else {
			$errorIcon = $('<a class="element__error-tooltip tooltip block--margin-left-half" data-error-icon data-tipso-class="error" title="' + errorMsg + '">!</a>');

			if (typeof $element.attr('data-selectric') !== 'undefined') {
				// Error icon handling exception with selectric dropdown
				$errorContainer = $element.parents('.selectric-wrapper');
			} else {
				$errorContainer = $element.parent();
			}

			$errorContainer.prepend($errorIcon);
		}
		$wrapper.addClass('sc-form__wrapper--show-error');
	}

	exports.init = init;
	return exports;

}());
